import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import classes from "./HomePage.module.css";
import { useNavigate } from "react-router-dom";
import LanguageSelector from "./LanguageSelector";
import { LanguageContext } from "./LanguageContext";
import bannerEN from "../images/GameBanner.png";
import bannerAR from "../images/arbicbanner.png";

const content = {
  "3": {
    title: "Door 2 Games",
    desc: "Dive into 50+ thrilling games across action, puzzle, sports, and more.",
    details: "Your details",
    mobile: "Mobile Number (MSISDN)",
    // placeholder: "e.g. 964*****",
    placeholder: "Enter your mobile number",
    subscribe: "Subscribe",
    subscribeText: "Subscribe to the Service",

    countryCode: "+964",

    // ✅ Cards content
    optoutTitle: "Opt-out method:",
    optoutDesc:
      "To unsubscribe anytime, reply STOP to ***** or visit *******. After unsubscribing, access will stop instantly.",

    subTitle: "Subscription Details",
    daily: "Daily Pack:",
    trial: "Free Trial:",
    price: "300 IQD / Day",
    trialText: "3 days free for new users only",

    infoTitle: "Additional Info",
    provider: "Provider:",
    help: "For help, contact support via the Help section in the portal.",

    subscribe: "Subscribe",
    subscribeText: "Subscribe to the Service",
    description2:
      "This service is a collection of special electronic games. For Asiacell subscribers, the first three days are free. After the free period ends, a fee of 300 IQD per day will be deducted. To cancel, send 0 for free to 2055.",
    description: "This service offers a collection of premium online games. New Asiacell subscribers enjoy the first three days free. After the free period, a daily charge of 300 Iraqi dinars will apply. To unsubscribe, send 0 to 2055 free of charge."
  },

  "2": {
    title: "باب 2 ألعاب",
    desc: "استمتع بأكثر من 50 لعبة ممتعة.",
    details: "بياناتك",
    mobile: "رقم الهاتف",
    // placeholder: "مثال: 964*****",
    placeholder: "أدخل رقم هاتفك المحمول",
    subscribe: "اشترك",
    subscribeText: "اشترك في الخدمة",

    countryCode: "964+",

    // ✅ Cards content
    optoutTitle: "طريقة الإلغاء:",
    optoutDesc: "لإلغاء الاشتراك، أرسل STOP.",

    subTitle: "تفاصيل الاشتراك",
    daily: "الباقة اليومية:",
    trial: "تجربة مجانية:",
    price: "300 IQD / يوم",
    trialText: "3 أيام مجانية",

    infoTitle: "معلومات إضافية",
    provider: "مزود الخدمة:",
    help: "للمساعدة، تواصل مع الدعم.",

    subscribe: "اشترك",
    subscribeText: "اشترك في الخدمة",
    description2: "هذه الخدمة عبارة عن مجموعة من الألعاب الإلكترونية المميزة. لمشتركي آسياسيل الجدد، أول ثلاثة أيام مجانية. بعد انتهاء الفترة المجانية سيتم خصم 300 دينار عراقي يومياً. لإلغاء الاشتراك، أرسل 0 مجاناً إلى 2055.",
    description: "هذه الخدمة عبارة عن مجموعة من الألعاب الإلكترونية المميزة. لمشتركي آسياسيل الجدد، أول ثلاثة أيام مجانية. بعد انتهاء الفترة المجانية سيتم خصم 300 دينار عراقي يومياً. لإلغاء الاشتراك، أرسل 0 مجاناً إلى 2055."
  },
};

const banners = {
  "3": bannerEN,
  "2": bannerAR,
};

const HomePage = () => {
  const [msisdn, setMsisdn] = useState("");
  const [clickID, setClickID] = useState("");
  const [mcpuniqid, setMcpuniqid] = useState("");
  const [antifraudId, setAntifraudId] = useState("")
  const { lang } = useContext(LanguageContext);
  const t = content[lang] || content["3"];
  // const currentBanner = banners[lang] || bannerEN;
  const currentBanner = bannerEN;

  const navigate = useNavigate();
  console.log(antifraudId, "id---")

  useEffect(() => {
    // document.body.dir = lang === "2" ? "rtl" : "ltr";
    document.body.dir = "ltr";

    const loadAntiFraud = async () => {
      try {
        const userIp = await getUserIP();

        const response = await axios.get("/antifraud", {
          params: {
            page: 1,
            userIp,
          },
        });
        console.log(response?.data?.data, "response----------")

        if (response.data.success) {
          const click = response.data.clickId;
          const mcp = response.data.mcpuniqid || "";
          const antifraud = response.data.antifrauduniqid

          setClickID(click);
          setMcpuniqid(mcp);
          setAntifraudId(antifraud)

          localStorage.setItem("clickID", click);
          localStorage.setItem("mcp", mcp);


          const scriptFromAPI = response?.data?.data;

          if (scriptFromAPI) {
            const oldScript = document.getElementById("anti-fraud-script");
            if (oldScript) {
              oldScript.remove();
            }

            const scriptTag = document.createElement("script");
            scriptTag.id = "anti-fraud-script";
            scriptTag.type = "text/javascript";

            scriptTag.textContent = scriptFromAPI;

            document.head.appendChild(scriptTag);
          }

          console.log("AntiFraud success:", response.data);
        } else {
          console.error("AntiFraud failed:", response.data);
        }
      } catch (err) {
        console.error(" AntiFraud error:", err);
      }
    };

    loadAntiFraud();
  }, [lang]);

  //  Get Public IP
  const getUserIP = async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");
      return res.data.ip;
    } catch (err) {
      console.error("IP fetch failed:", err);
      return "0.0.0.0";
    }
  };

  // Subscribe Flow
  const handleSubscribe = async () => {
    if (!msisdn) {
      alert("Please enter MSISDN");
      return;
    }

    try {
      // Step 1: AntiFraud


      const clickID = localStorage.getItem("clickID");
      const mcp = localStorage.getItem("mcp");

      if (!clickID || !mcp) {
        alert("AntiFraud not ready yet");
        return;
      }

      let msisdnWithCountryCode = msisdn;

      if (!msisdnWithCountryCode.startsWith('964')) {
        msisdnWithCountryCode = '964' + msisdnWithCountryCode;
      }

      const response = await axios.get(
        "/otp/sendOTP",
        {
          params: {
            user: "Digitalabs",
            password: "DiGit0L02022",
            msisdn: msisdnWithCountryCode,
            shortcode: "2055",
            serviceId: "22",
            spId: "3021",
            LanguageID: lang === "2" ? "2" : "3",
            ChannelID: "22800",
            // ClickID: clickID,
            ClickID: antifraudId,
          },
        }
      );

      console.log("OTP Response:", response);

      //  Navigate
      navigate(`/verifyotp?uniqid=${mcp}&msisdn=${msisdnWithCountryCode}&ClickID=${antifraudId}`);

    } catch (error) {
      console.error("Subscribe error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  // await fetchAntiFraud(msisdn);

  // const clickID = localStorage.getItem("clickID");
  // const mcp = localStorage.getItem("mcp");

  //   if (!clickID || !mcp) {
  //     alert("AntiFraud not ready yet");
  //     return;
  //   }

  //   await fetch(
  //     `http://host/sendPincode?msisdn=${msisdn}&ClickID=${clickID}`
  //   );

  //   navigate(`/confirm?uniqid=${mcp}&msisdn=${msisdn}`);
  // };

  return (
    <div className={classes.section_hero}>
      <LanguageSelector />

      {/* Hero */}
      <div className={classes.slider_content}>
        {/* <h2>{t.title}</h2> */}
        <h2>Door 2 Games</h2>
        <p>{t.desc}</p>
      </div>

      {/* Banner */}
      <div className={classes.banner_wrapper}>
        <img
          src={currentBanner}
          alt="Banner"
          className={classes.banner_img}
        />
      </div>

      <div className={classes.login_cards_wrapper}>
        {/* Login Section */}
        <div className={classes.login_container}>
          <p className={classes.login_subtitle}>{t.details}</p>

          <label className={classes.login_label}>{t.mobile}</label>

          <div className={classes.input_container}>
            <div className={classes.input_country_code}>
              {/* {t.countryCode} */}
              +964
            </div>
            <input
              type="tel"
              placeholder={t.placeholder}
              value={msisdn}
              // inputMode="tel"
              onChange={(e) => setMsisdn(e.target.value)}
              maxLength="15"
              className={classes.login_input}
            />

          </div>

          <button
            onClick={handleSubscribe}
            className={classes.login_button}
          >
            {t.subscribe}
          </button>

          {/* <p className={classes.subscribe_text}>
            {t.subscribeText}
          </p> */}



        </div>

        <p className={classes.subscribe_text}>
          {t.subscribeText}
        </p>

        {/* Description */}
        <div className={classes.description_box}>
          <p>{t.description}</p>
        </div>


      </div>

      <div className={classes.partner_logo_container}>
        <div className={classes.partner_logo}></div>
      </div>
    </div>
  );
};

export default HomePage;